export enum FormType {
  INSCRIPTION = 'INSCRIPTION',
  INCREMENTAL = 'INCREMENTAL',
  CONFIRMATION = 'CONFIRMATION',
  REGISTRATION = 'REGISTRATION',
}